"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCompanyApi = exports.CompanyApiOptions = void 0;
var num_client_1 = require("num-client");
var Contacts_1 = __importDefault(require("./Contacts"));
var CompanyApiOptions = (function () {
    function CompanyApiOptions(init) {
        this.contactsDepth = Number.MAX_SAFE_INTEGER;
        this.imagesDepth = Number.MAX_SAFE_INTEGER;
        this.moduleVersionMap = new Map();
        this.language = 'en';
        this.country = 'us';
        Object.assign(this, init);
        if (!Number.isInteger(this.contactsDepth) || this.contactsDepth < 0) {
            this.contactsDepth = 0;
        }
        if (!Number.isInteger(this.imagesDepth) || this.imagesDepth < 0) {
            this.imagesDepth = 0;
        }
        if (this.moduleVersionMap.size === 0) {
            this.moduleVersionMap = new Map();
            this.moduleVersionMap.set(1, '2');
        }
    }
    return CompanyApiOptions;
}());
exports.CompanyApiOptions = CompanyApiOptions;
var createCompanyApi = function (numClient) { return new CompanyApiImpl(numClient); };
exports.createCompanyApi = createCompanyApi;
var CompanyApiImpl = (function () {
    function CompanyApiImpl(numClient) {
        this.client = numClient ? numClient : (0, num_client_1.createClient)();
    }
    CompanyApiImpl.prototype.lookupUri = function (uri, options) {
        var theOptions = new CompanyApiOptions(options);
        var lookup = new Lookup({}, uri.withPort(num_client_1.MODULE_1), uri.withPort(num_client_1.MODULE_3));
        var uriMap = new Map();
        return retrieveRecord(this.client, lookup, uriMap, theOptions).then(function (result) {
            var response = result['numObject'] ? result['numObject'] : result;
            return collectErrorMetadata(response, uriMap);
        });
    };
    CompanyApiImpl.prototype.lookupDomain = function (domain, options) {
        return this.lookupUri((0, num_client_1.buildNumUri)(domain), options);
    };
    return CompanyApiImpl;
}());
var collectErrorMetadata = function (data, uriMap) {
    var e_1, _a;
    var metadata = {
        errors: [],
    };
    try {
        for (var uriMap_1 = __values(uriMap), uriMap_1_1 = uriMap_1.next(); !uriMap_1_1.done; uriMap_1_1 = uriMap_1.next()) {
            var _b = __read(uriMap_1_1.value, 2), uri = _b[0], promiseAndHandler = _b[1];
            if (promiseAndHandler.handler && promiseAndHandler.handler.getErrorCode() != null) {
                var err = { uri: uri, error: promiseAndHandler.handler.getErrorCode(), moduleNumber: (0, num_client_1.parseNumUri)(uri).port.n };
                metadata.errors.push(err);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (uriMap_1_1 && !uriMap_1_1.done && (_a = uriMap_1.return)) _a.call(uriMap_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    data['metadata'] = metadata;
    return data;
};
var retrieveRecord = function (client, lookup, usedUris, optionsParam) {
    if (optionsParam.contactsDepth <= 0) {
        return Promise.resolve({});
    }
    var options = new CompanyApiOptions(optionsParam);
    options.contactsDepth = options.contactsDepth - 1;
    options.imagesDepth = options.imagesDepth - 1;
    var contactsUriString = lookup.contactsUri.toString();
    if (!usedUris.has(contactsUriString)) {
        var handler_1 = (0, num_client_1.createDefaultCallbackHandler)();
        var contactsContext = client.createContext(lookup.contactsUri);
        contactsContext.setUserVariable('_L', optionsParam.language ? optionsParam.language : 'en');
        contactsContext.setUserVariable('_C', optionsParam.country ? optionsParam.country : 'us');
        var contactsModuleTargetVersion = options.moduleVersionMap.get(1);
        contactsContext.setTargetExpandedSchemaVersion(contactsModuleTargetVersion ? contactsModuleTargetVersion : '2');
        var contactsPromise = client.retrieveNumRecord(contactsContext, handler_1);
        usedUris.set(contactsUriString, { promise: contactsPromise, handler: handler_1 });
        var imagesPromise_1;
        var imagesUriString = lookup.imagesUri.toString();
        if (!usedUris.has(imagesUriString) && optionsParam.imagesDepth > 0) {
            var imagesHandler = (0, num_client_1.createDefaultCallbackHandler)();
            var imagesModuleContext = client.createContext(lookup.imagesUri);
            imagesModuleContext.setUserVariable('_L', optionsParam.language ? optionsParam.language : 'en');
            imagesModuleContext.setUserVariable('_C', optionsParam.country ? optionsParam.country : 'us');
            var imagesModuleTargetVersion = options.moduleVersionMap.get(3);
            imagesModuleContext.setTargetExpandedSchemaVersion(imagesModuleTargetVersion ? imagesModuleTargetVersion : '1');
            imagesPromise_1 = client.retrieveNumRecord(imagesModuleContext, imagesHandler);
            usedUris.set(imagesUriString, { promise: imagesPromise_1, handler: imagesHandler });
        }
        return contactsPromise.then(function (contacts) {
            var contactsObject = contacts !== null ? Contacts_1.default.transform(JSON.parse(contacts), { _C: optionsParam.country, _L: optionsParam.language }, null) : {};
            delete contactsObject['numVersion'];
            for (var k in contactsObject) {
                if (k !== 'populated' && k !== '@version') {
                    if (handler_1.getErrorCode() != null) {
                        var co = contactsObject;
                        co[k]['metadata'] = { status: handler_1.getErrorCode() };
                    }
                    lookup.link[k] = contactsObject[k];
                    if (contactsObject['populated']) {
                        var o = contactsObject[k];
                        o['populated'] = contactsObject['populated'];
                    }
                    break;
                }
            }
            var subRecordsPromise = followLinks(client, usedUris, contactsObject, lookup.contactsUri, options);
            if (imagesPromise_1) {
                return imagesPromise_1.then(function (images) {
                    if (images !== null) {
                        var imagesObject = JSON.parse(images).images;
                        if (contactsObject['numObject']) {
                            contactsObject['numObject'].images = imagesObject;
                        }
                    }
                    return Promise.all([imagesPromise_1, subRecordsPromise]).then(function () {
                        return subRecordsPromise;
                    }, handleError);
                }, handleError);
            }
            return subRecordsPromise;
        }, handleError);
    }
    else {
        var contactsUriPromise_1 = usedUris.get(contactsUriString);
        return contactsUriPromise_1.promise.then(function (contacts) {
            var contactsObject = contacts !== null ? Contacts_1.default.transform(JSON.parse(contacts), { _C: optionsParam.country, _L: optionsParam.language }, null) : {};
            delete contactsObject['numVersion'];
            delete contactsObject['populated'];
            for (var k in contactsObject) {
                if (contactsUriPromise_1.handler.getErrorCode() != null) {
                    var co = contactsObject;
                    co[k]['metadata'] = { status: contactsUriPromise_1.handler.getErrorCode() };
                }
                lookup.link[k] = contactsObject[k];
                break;
            }
            return contactsObject;
        }, handleError);
    }
};
var followLinks = function (client, usedUris, jsonObj, currentUri, optionsParam) {
    var promises = findLinks(jsonObj, currentUri).map(function (l) {
        var lookup = new Lookup(l.link, l.uri.withPort(num_client_1.MODULE_1), l.uri.withPort(num_client_1.MODULE_3));
        return retrieveRecord(client, lookup, usedUris, optionsParam);
    });
    return Promise.all(promises).then(function () {
        return jsonObj;
    }, handleError);
};
var handleError = function (reason) {
    throw new Error(reason);
};
var findLinks = function (obj, uri) {
    var links = new Array();
    for (var k in obj) {
        if (k === 'method_type' && obj[k] === 'link' && obj['@L']) {
            var link = obj;
            var path = link['@L'];
            var newUri = path.startsWith('num://')
                ? (0, num_client_1.parseNumUri)(path)
                : path.startsWith('/')
                    ? uri.withPath(new num_client_1.UrlPath(path))
                    : uri.path.s.endsWith('/')
                        ? uri.withPath(new num_client_1.UrlPath(uri.path.s + path))
                        : uri.withPath(new num_client_1.UrlPath(uri.path.s + '/' + path));
            links.push(new Link(link, newUri));
        }
        else {
            var value = obj[k];
            if (value !== null && typeof value === 'object') {
                findLinks(value, uri).forEach(function (l) { return links.push(l); });
            }
        }
    }
    return links;
};
var Lookup = (function () {
    function Lookup(link, contactsUri, imagesUri) {
        this.link = link;
        this.contactsUri = contactsUri;
        this.imagesUri = imagesUri;
    }
    return Lookup;
}());
var Link = (function () {
    function Link(link, uri) {
        this.link = link;
        this.uri = uri;
    }
    return Link;
}());
//# sourceMappingURL=CompanyApi.js.map